/*  Plugins */
import { registerPlugins } from '@/plugins/initPlugins';
import '@/styles/index.css';
import { createApp } from 'vue';

import App from './App.vue';
import { initAxios } from './plugins/axios';
import { initSentry } from './plugins/initSentry';
import { initPrimeVue } from './plugins/primevue';

const app = createApp(App);

initAxios();
registerPlugins(app);
initPrimeVue(app);
initSentry(app);

app.mount('#app');
